export const PDFNoteStatusVals = {
  OnCheck: 1,
  ExpertCorrection: 2,
  GIPApproved: 3,
  Completed: 4,
  CompletionConfirmed: 5,
  NotCompleted: 6,
  CanceledByGIP: 7,
  InWorkByGIP: 8,
  CanceledByInitiator: 9,
  Guarantee: 10,
  New: 11
}

export function getPDFNoteStatusBadge(statusId?: number) {
  switch (statusId) {
    case PDFNoteStatusVals.New:
    case PDFNoteStatusVals.OnCheck:
    case PDFNoteStatusVals.ExpertCorrection:
    case PDFNoteStatusVals.GIPApproved:
    case PDFNoteStatusVals.NotCompleted:
    case PDFNoteStatusVals.InWorkByGIP:
    case PDFNoteStatusVals.CanceledByInitiator:
      return `badge badge-secondary`;
    case PDFNoteStatusVals.Completed:
    case PDFNoteStatusVals.CompletionConfirmed:
    case PDFNoteStatusVals.CanceledByGIP:
    case PDFNoteStatusVals.Guarantee:
      return `badge badge-success`;
    default:
      return ``;
  }
}

export function getPDFNoteStatusDisplayName(statusId?: number) {
  switch (statusId) {
    case PDFNoteStatusVals.New:
    case PDFNoteStatusVals.OnCheck:
    case PDFNoteStatusVals.ExpertCorrection:
    case PDFNoteStatusVals.GIPApproved:
    case PDFNoteStatusVals.NotCompleted:
      return `Не выполнено`;
    case PDFNoteStatusVals.Completed:
    case PDFNoteStatusVals.CompletionConfirmed:
    case PDFNoteStatusVals.CanceledByGIP:
      return `Выполнено`;
    case PDFNoteStatusVals.Guarantee:
      return `Гарантийное`;
    default:
      return ``;
  }
}